import { render, staticRenderFns } from "./CampaignEditor.vue?vue&type=template&id=27397cc4&scoped=true&"
import script from "./CampaignEditor.vue?vue&type=script&lang=js&"
export * from "./CampaignEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27397cc4",
  null
  
)

export default component.exports